import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login.vue'
import Index from '../views/index/index.vue'

Vue.use(VueRouter)

/**
 * hidden: true             // 默认false,当设置true的时候该路由不会在侧边栏出现，如401，login等页面
 * meta: {
    keepAlive: false      // 如果设置为false，则不会被 <keep-alive> 缓存(默认 true)
 * }
 */

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/index',
    redirect: '/timeData',
    component: Index,
    children: [
      {
        path: '/timeData',
        name: 'timedata',
        component: () => import('@/views/index/child/timeData.vue'),
        meta: {
          icon: 'icon-tongyonglei_shuju_yibiaopan_tongji',
          title: '实时数据',
          fresh: 1
        }
      },
      {
        path: '/deviceList',
        name: 'deviceList',
        component: () => import('@/views/index/child/deviceList.vue'),
        meta: {
          icon: 'icon-tongyonglei_shebei_shuju',
          title: '设备列表',
          fresh: 1
        }
      },
      {
        path: '/compareData',
        name: 'compareData',
        component: () => import('@/views/index/child/compareData.vue'),
        meta: {
          icon: 'icon-tongyonglei_shuju_duibi',
          title: '数据对比',
          fresh: 1
        }
      },
      {
        path: '/DataList',
        name: 'DataList',
        component: () => import('@/views/index/child/dataList.vue'),
        meta: {
          title: '数据对比',
          fresh: 0
        }
      },
      {
        path: '/DataPage',
        name: 'DataPage',
        component: () => import('@/views/index/child/dataPage.vue'),
        meta: {
          title: '数据详情',
          fresh: 0
        }
      },
      {
        path: '/sortData',
        name: 'sortData',
        component: () => import('@/views/index/child/sortData.vue'),
        meta: {
          icon: 'icon-tongyonglei_shuju_liebiao',
          title: '统计排序',
          fresh: 1
        }
      },
      {
        path: '/hotMap',
        name: 'hotMap',
        component: () => import('@/views/index/child/hotMap.vue'),
        meta: {
          icon: 'icon-bianjilei_dingwei2',
          title: '热力图',
          fresh: 1
        }
      },
      {
        path: '/noise',
        name: 'noise',
        component: () => import('@/views/index/child/noise.vue'),
        meta: {
          icon: 'el-icon-microphone',
          title: '噪音',
          fresh: 1
        }
      },
      {
        path: '/alarmTrigger',
        name: 'alarmTrigger',
        component: () => import('@/views/index/child/alarmTrigger.vue'),
        meta: {
          icon: '',
          title: '报警触发',
          fresh: 0
        }
      },
      {
        path: '/triggerRecord',
        name: 'triggerRecord',
        component: () => import('@/views/index/child/triggerRecord.vue'),
        meta: {
          icon: '',
          title: '触发记录',
          fresh: 0
        }
      },
      {
        path: '/contactList',
        name: 'contactList',
        component: () => import('@/views/index/child/contactList.vue'),
        meta: {
          icon: '',
          title: '联系人列表',
          fresh: 0
        }
      },
      {
        path: '/warning',
        name: 'warning',
        meta: {
          icon: 'icon-tongyonglei_baojing_chufaqi',
          title: '污染报警',
          fresh: 1
        },
        children: [
          {
            path: '/alarmTrigger',
            name: 'alarmTrigger',
            component: () => import('@/views/index/child/alarmTrigger.vue'),
            meta: {
              icon: '',
              title: '报警触发',
              fresh: 1
            }
          },
          {
            path: '/triggerRecord',
            name: 'triggerRecord',
            component: () => import('@/views/index/child/triggerRecord.vue'),
            meta: {
              icon: '',
              title: '触发记录',
              fresh: 1
            }
          },
          {
            path: '/contactList',
            name: 'contactList',
            component: () => import('@/views/index/child/contactList.vue'),
            meta: {
              icon: '',
              title: '联系人列表',
              fresh: 1,
            }
          }
        ]
      },
    ],
  }
]

const router = new VueRouter({
  // mode: 'history', // 去掉url中的#
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/login') {
    if (window.localStorage.getItem('token')) {
      next()
    } else {
      router.push('/login')
    }
  } else {
    if (window.localStorage.getItem('token')) {
      router.push('/index')
    } else {
      next()
    }
  }
})
export default router
